/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Timeline context
import { useTimeline } from "examples/Timeline/context";

// Custom styles for the TimelineItem
import timelineItem from "examples/Timeline/TimelineItem/styles";
import dayjs from "dayjs";

function TimelineItem({
  event: title,
  createdOn: dateTime,
  docNo1: description,
  message,
  lastItem,
  createdBy=null
}) {
  const isDark = useTimeline();

  let color = "info";
  let icon = "add";
  if (title === "EDIT") {
    color = "success";
    icon = "edit";
  } else if (title === "CANCEL") {
    color = "warning";
    icon = "close";
  }

  let dateTimeString = dayjs(dateTime).format("DD/MM/YYYY HH:mm");

  return (
    <MDBox position="relative" mb={3} sx={(theme) => timelineItem(theme, { lastItem, isDark })}>
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgColor={color}
        color="white"
        width="2rem"
        height="2rem"
        borderRadius="50%"
        position="absolute"
        top="8%"
        left="2px"
        zIndex={2}
        sx={{ fontSize: ({ typography: { size } }) => size.sm }}
      >
        <Icon fontSize="inherit">{icon}</Icon>
      </MDBox>
      {title === "EDIT" || title === "PUTAWAY_EDIT" ? (
        <MDBox ml={5.75} pt={description ? 0.7 : 0.5} lineHeight={0} maxWidth="30rem">
          <MDTypography variant="button" fontWeight="medium" color={isDark ? "white" : "dark"}>
            {title}
          </MDTypography>
          <MDBox mt={0.5}>
            <MDTypography variant="caption" color={isDark ? "secondary" : "text"}>
              <b>
                {description} on {dateTimeString}
              </b>
            </MDTypography>
          </MDBox>
          <MDBox mt={0.5} mb={1}>
            {description && message ? (
              <MDTypography variant="button" color={isDark ? "white" : "dark"}>
                {message.split("|").map((x,index) => (
                  <p key={index}>{x}</p>
                ))}
                <p style={{fontWeight:"bold"}}>Edited by: {createdBy??""}</p>
              </MDTypography>
            ) : null}
          </MDBox>
        </MDBox>
      ) : (
        <MDBox ml={5.75} pt={description ? 0.7 : 0.5} lineHeight={0} maxWidth="30rem">
          <MDTypography variant="button" fontWeight="medium" color={isDark ? "white" : "dark"}>
            {description}
          </MDTypography>
          <MDBox mt={0.5}>
            <MDTypography variant="caption" color={isDark ? "secondary" : "text"}>
              <b>
                {message} on {dateTimeString}
              </b>
              <p style={{fontWeight:"bold",fontSize:"0.875rem", color:"black"}}>User: {createdBy??""}</p>
            </MDTypography>
          </MDBox>
        </MDBox>
      )}
    </MDBox>
  );
}

// Setting default values for the props of TimelineItem
TimelineItem.defaultProps = {
  color: "info",
  lastItem: false,
  description: "",
};

// Typechecking props for the TimelineItem
TimelineItem.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  //icon: PropTypes.node.isRequired,
  //title: PropTypes.string.isRequired,
  //dateTime: PropTypes.string.isRequired,
  description: PropTypes.string,
  lastItem: PropTypes.bool,
};

export default TimelineItem;
